 
	import EnderecoService  from '@/service/v10/sigap/EnderecoService'; 
	import $ from "jquery"  
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import EnderecoAtualizar from   "./_Atualizar.vue"  
    import { Options , Vue } from "vue-class-component";   
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
    import { Watch,  Prop } from 'vue-property-decorator';   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
	import { namespace } from 'vuex-class';   
    const authStore = namespace('auth');
    import { User } from "@/store/modules/AuthModule";
    import EnderecoCadastro from   "./_Cadastrar.vue" 


    @Options({
        name: "Endereco",
        components: {  CardRh , KDataTable , EnderecoAtualizar , EnderecoCadastro},   
    }) 
    export default class Endereco extends Vue {
         
        @authStore.Getter
		public currentUser!: User 
         
        @Prop( ) readonly model_watch!: any
        @Prop( ) readonly modal_cadastro!: any 

        public modelo = null ; 
        public processando = false; 
        public reloadDatatable = false ;
        public config; 
        public service; 
        public kt_atualizar; 

        get hasPermissao(   ): boolean {
            return true;
        }
 
        created(){
            this.config = {  ajax: {} , columns: [] , columnDefs: [] }; 
            this.service = new EnderecoService();  
            this.config.ajax = { 
                url: this.service.getApiUrl()   ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length, 
                        "search": d.search.value
                    }
                    return dados; 
                } 
            };   
            this.kt_atualizar = 'kt_atualizar_enderecos_profile'; 
            this.config.columns = [ 
                { data: 'id', name: 'id' }, 
                { data: 'logradouro', name: 'logradouro' }, 
                { data: 'cep', name: 'cep' }, 
                { data: 'complemento', name: 'complemento' }, 
                { data: 'bairro', name: 'bairro' }, 
                { data: 'numero', name: 'numero' }, 
                { data: 'cidade', name: 'cidade' }, 
                { data: 'uf', name: 'uf' }, 
                { data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' }
            ];
            this.config.columnDefs = [ 
                {
                    targets: 8 ,
                    render: ( row, type, val, meta ) => {    
                        let texto = '' ;
                        for (var key in val) {  texto = texto + ' data-' + key + '="'+ val[key] +'"'  }  
                        
                        return  '<button class="btn btn-pmes-warning btn-sm" btn-editar ' + texto + ' data-bs-toggle="modal" data-bs-target="#' +
                        this.kt_atualizar   + '"> Editar </button>' + '&emsp;' +
                        '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + texto + ' >Excluir </button>'  ; 
                    }, 
                }
            ]; 
        }
          
        public tableatualizada( event ) {   
            $('[btn-excluir]').click(  (btn) => {  
                const id =   $(btn.currentTarget).data('id');  
                this.excluirModelo(id ); 
            }); 
            $('[btn-editar]').click(  (btn) => {   
                this.modelo =  $(btn.currentTarget).data( ) ; 
            }); 
        }  
  
        protected excluirModelo( id  ) {  
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                            this.service.excluirMy( id )
                        .then(response => {     
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );  
        }  
    
        @Watch('model_watch')
		modeloAlterado(newVal: string) {
            this.modelo = null;
			this.reloadDatatable = !this.reloadDatatable; 
		}
 
    } 
